"use client";
import React, { useEffect } from "react";
import { deleteDocumentCookie, setDocumentCookie } from "@packages/lib/utlils/cookie-utils";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
const SrPageNoResults = ({ searchPayLoad, displayNameResponse }: any) => {
  useEffect(() => {
    deleteDocumentCookie([
         { name: "min" },
         { name: "ucaspoint" },
         { name: "UCAS" },
       ]);
    const filtervalues = JSON.parse(sessionStorage.getItem("filter_param") || "{}");
    delete filtervalues["score"]
    sessionStorage.setItem("filter_param", JSON.stringify(filtervalues));
    setDocumentCookie({name:"filter_param", value:JSON.stringify(filtervalues)});
    const footer: any = document.getElementById("footerComponent");
    const bodyContainer: any = document.getElementById("bodyContainer");
    emitter.emit("searchpageloading", false);
    bodyContainer?.classList?.remove("hidden");
    footer?.classList?.remove("hidden");
  }, []);
  const subjectArray = displayNameResponse?.subjectName?.map((subject: any) => {
    return subject?.description;
  });
  return (
    <>
      <div className="px-[16px] md:px-[20px] xl:px-0 py-[40px] md:py-[56px]">
        <div className="flex gap-[16px]">
          <div className="flex flex-col gap-[4px]">
            <div className="para-lg font-bold font-farro">
              Well, that's unexpected!
            </div>
            <div className="small">
              We couldn’t find any matches for{" "}
              {subjectArray?.join(", ") ||
                searchPayLoad?.searchSubject?.join(", ") ||
                searchPayLoad?.searchKeyword}
            </div>
            <ul className="list-disc small mt-[20px] ml-[20px]">
              <li>
                Not what you expected? Try a new search term or check for typos.
              </li>
              <li>Let’s find what you’re looking for!</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SrPageNoResults;
